export const HEALTHSCRIBE_AUDIO_INTERRUPTION_EVENT =
  "healthscribe-audio-interruption";

export interface HealthScribeAudioInterruptionDetail {
  source: "telehealth" | "microphone";
  reason: "context-closed" | "frames-stalled";
}

export const dispatchHealthScribeAudioInterruption = (
  detail: HealthScribeAudioInterruptionDetail
): void => {
  window.dispatchEvent(
    new CustomEvent<HealthScribeAudioInterruptionDetail>(
      HEALTHSCRIBE_AUDIO_INTERRUPTION_EVENT,
      { detail }
    )
  );
};
